import { useLanguage } from '../context/LanguageContext';
import { translations, testimonials } from '../data/translations';
import { Quote } from 'lucide-react';

const TestimonialsSection = () => {
  const { t } = useLanguage();

  return (
    <section 
      id="testimonials" 
      className="section-padding bg-[#050505] relative overflow-hidden"
      data-testid="testimonials-section"
    >
      {/* Background decorations */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-emerald-500/30 to-transparent" />
      <div className="absolute left-1/4 top-1/2 w-80 h-80 bg-emerald-500/5 rounded-full blur-3xl" />

      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4"
            data-testid="testimonials-title"
          >
            {t(translations.testimonials.sectionTitle)}
          </h2>
          <p className="text-base md:text-lg text-white/60 max-w-2xl mx-auto">
            {t(translations.testimonials.sectionSubtitle)}
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <div 
              key={testimonial.id}
              className="testimonial-card group relative"
              data-testid={`testimonial-${testimonial.id}`}
            >
              <div className="absolute top-6 right-6 text-emerald-500/20 group-hover:text-emerald-500/40 transition-colors">
                <Quote className="w-10 h-10" />
              </div>

              <div className="relative z-10">
                <p className="text-white/70 leading-relaxed mb-6 italic">
                  "{t(testimonial.quote)}"
                </p>

                <div className="flex items-center gap-4 pt-4 border-t border-white/10">
                  <img 
                    src={testimonial.image}
                    alt={t(testimonial.name)}
                    className="w-12 h-12 rounded-full object-cover"
                    loading="lazy"
                  />
                  <div>
                    <h4 className="font-semibold text-white">
                      {t(testimonial.name)}
                    </h4>
                    <p className="text-sm text-emerald-500">
                      {t(testimonial.role)}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
